import React from 'react';

/**
 * One APA string with its formatting kept: the italic "Note.", an italic title
 * in a reference entry, and the Creative Commons licence as a real link.
 *
 * Every APA formatter returns the same `segments` shape
 * (`{ text, italic?, href? }`), so one component draws a figure note, a table
 * note and a reference entry alike. Only http(s) links become anchors.
 */
const ApaSegments = ({ segments = [], linkClassName = 'text-indigo-600 hover:text-indigo-800 hover:underline' }) => (
  <>
    {(segments || []).filter((segment) => segment && segment.text).map((segment, index) => {
      const body = segment.italic ? <em>{segment.text}</em> : segment.text;
      const key = `apa-segment-${index}`;
      if (!/^https?:\/\//i.test(segment.href || '')) {
        return <React.Fragment key={key}>{body}</React.Fragment>;
      }
      return (
        <a key={key} href={segment.href} target="_blank" rel="noreferrer" className={linkClassName}>
          {body}
        </a>
      );
    })}
  </>
);

export default ApaSegments;
